import SocialMediaList from '@uikit/components/SocialMediaList/SocialMediaList';
import type { MagazineStageBoxArticleProps } from './interfaces';
import styles from './MagazineStageBoxArticle.module.scss';
import { SocialMediaItem } from '../../SocialMediaList/interfaces';

const MagazineStageBoxArticle = ({
  title,
  subTitle,
  articlePagePath,
}: MagazineStageBoxArticleProps) => {
  const ARTICLE_DETAIL_HEADER_SOCIAL_MEDIA_LIST: SocialMediaItem[] = [
    {
      icon: 'user/mail',
      url:
        'mailto:?subject=' + title + '&body=' + title + ' ' + articlePagePath,
      title: 'Artikel über Mail teilen',
    },
    {
      icon: 'action/facebook',
      url: 'http://www.facebook.com/share.php?u=' + articlePagePath,
      title: 'Artikel über Facebook teilen',
    },
    {
      icon: 'action/twitter',
      url: encodeURI(
        'https://twitter.com/intent/tweet?text=' + title + ' ' + articlePagePath
      ),
      title: 'Artikel über Twitter teilen',
    },
  ];

  return (
    <>
      {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
      {title && <h1 className={styles.title}>{title}</h1>}
      <SocialMediaList
        items={ARTICLE_DETAIL_HEADER_SOCIAL_MEDIA_LIST}
        className={styles.socialMediaList}
      />
    </>
  );
};

export default MagazineStageBoxArticle;
